import milon from "../res/images/New folder (2)/mm.jpg";

// Kept separate from logos.js so the navbar/login don't pull in every brand image.
export const DEFAULT_BUSINESS_LOGO = milon;
